import React, { useEffect } from 'react';
import Image from 'next/image';
import SearchBox from './SearchBox';
import AdvisorCard from 'components/Common/AdvisorCard';
import { useDispatch, useSelector } from 'react-redux';
import { getSkillsAction } from 'store/course/course.action';
import { ConsultingType } from 'types/course.type';
import Questions from './questions';
import MoreData from './moreData';
import AskUs from 'components/landing/askUs';
import Footer from 'components/Consulting/footer';

const Home: React.FC<{ data: ConsultingType }> = ({ data }) => {
  const dispatch = useDispatch();
  const skills = useSelector((state) => state.course.skills);

  useEffect(() => {
    !skills && dispatch(getSkillsAction());
  }, [skills]);

  return (
    <div className="bg-black10">
      <div className="relative bg-other3">
        <div className="absolute bottom-0 right-0 z-0 hidden h-[379px] xl:block">
          <Image src="/home-bg.png" width={679} height={379} alt="" />
        </div>

        <div className="py-[80px] md:py-[120px] duration-300 xl:py-[220px] px-[32px] md:px-[64px]">
          <SearchBox skills={skills} />
        </div>
      </div>
      <div className="isCenter flex flex-wrap gap-[40px] justify-center py-[60px] md:py-[100px]">
        {data.counselors.map((advisor) => (
          <AdvisorCard {...{ advisor }} key={advisor.id} />
        ))}
      </div>

      <MoreData data={data} />

      <Questions data={data} />
      <AskUs />
      <Footer />
    </div>
  );
};

export default Home;
